var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { keyframes } from "styled-components";
export var flash = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n"], ["\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n"])));
var FlashItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:active {\n    animation: ", " 0.25s linear;\n  }\n"], ["\n  &:active {\n    animation: ", " 0.25s linear;\n  }\n"])), flash);
/** @component */
export default FlashItem;
var templateObject_1, templateObject_2;
